<div class="flex select-none flex-col gap-4">
    <app-user-search-title [title]="texts().header.title | translate" [text]="texts().header.text | translate" />
    <app-user-search-bar
        [firstNameLabel]="texts().searchBar.firstName | translate"
        [lastNameLabel]="texts().searchBar.lastName | translate"
        [gidLabel]="texts().searchBar.gid | translate"
        (search)="onSearch($event)"
    />

    @if (hasError()) {
        <p class="m-0 text-sm text-[var(--color-status-error)]">{{ texts().search.error | translate }}</p>
    } @else if (isLoading()) {
        <div class="flex items-center justify-center p-1">
            <sh-spinner size="m" />
        </div>
    } @else if (results().length > 0) {
        <div class="flex flex-col gap-2">
            <div class="grid grid-cols-3 rounded-md px-4 py-2 select-none">
                <span class="text-sm text-[var(--color-text-subtle)]">{{ texts().search.table.name | translate }}</span>
                <span class="text-sm text-[var(--color-text-subtle)]">{{ texts().search.table.gid | translate }}</span>
                <span class="text-sm text-[var(--color-text-subtle)]">{{
                    texts().search.table.department | translate
                }}</span>
            </div>

            <ul class="flex max-h-40 flex-col gap-2 overflow-y-auto">
                @for (person of results(); track person.employeeId) {
                    <li
                        class="grid grid-cols-3 items-center rounded-lg border border-[var(--colorGrey)] px-4 py-3 text-sm text-[var(--color-text-active)] outline-none transition-colors hover:bg-[var(--secondary-button-hover-background)] focus-visible:ring-2 focus-visible:ring-white cursor-pointer"
                        role="button"
                        tabindex="0"
                        (click)="onSelect(person)"
                    >
                        <span>{{ person.givenName }} {{ person.surname }}</span>
                        <span>{{ person.employeeId }}</span>
                        <span>{{ person.department }}</span>
                    </li>
                }
            </ul>
        </div>
    } @else {
        <p class="m-0 text-base text-[var(--color-text-subtle)]">{{ texts().search.empty | translate }}</p>
    }
</div>
